import React from 'react';

import { Row, Col } from 'antd';
import Input from 'components/Common/Form/Input/Input';
import { Container } from './styles';

interface IProps {
	exigenciasIP: string[];
	exigenciasDelegacia: string[];
	exigenciasInstauracao: string[];
}
interface IData {
	data: IProps;
}

const IPN: React.FC<IData> = ({ data }) => {
	return (
		<Container>
			<Row gutter={15}>
				<Col span={6}>
					<h5>IP Nº</h5>
				</Col>
				<Col span={12}>
					<h5>Delegacia</h5>
				</Col>
				<Col span={6}>
					<h5>Data Instauração</h5>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP01"
						value={(data?.exigenciasIP && data.exigenciasIP[0]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia01"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[0]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao01"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[0]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP02"
						value={(data?.exigenciasIP && data.exigenciasIP[1]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia02"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[1]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao02"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[1]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP03"
						value={(data?.exigenciasIP && data.exigenciasIP[2]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia03"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[2]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao03"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[2]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP04"
						value={(data?.exigenciasIP && data.exigenciasIP[3]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia04"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[3]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao04"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[3]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP05"
						value={(data?.exigenciasIP && data.exigenciasIP[4]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia05"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[4]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao05"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[4]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP06"
						value={(data?.exigenciasIP && data.exigenciasIP[5]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia06"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[5]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao06"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[5]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP07"
						value={(data?.exigenciasIP && data.exigenciasIP[6]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia07"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[6]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao07"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[6]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP08"
						value={(data?.exigenciasIP && data.exigenciasIP[7]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia08"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[7]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao08"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[7]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP09"
						value={(data?.exigenciasIP && data.exigenciasIP[8]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia09"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[8]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao09"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[8]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
			<Row gutter={[16, 16]}>
				<Col span={6}>
					<Input
						name="exigenciaIP10"
						value={(data?.exigenciasIP && data.exigenciasIP[9]) || ''}
						disabled
					/>
				</Col>
				<Col span={12}>
					<Input
						name="exigDelegacia10"
						value={
							(data?.exigenciasDelegacia && data.exigenciasDelegacia[9]) || ''
						}
						disabled
					/>
				</Col>
				<Col span={6}>
					<Input
						name="exigInstauracao10"
						value={
							(data?.exigenciasInstauracao && data.exigenciasInstauracao[9]) ||
							''
						}
						disabled
					/>
				</Col>
			</Row>
		</Container>
	);
};

export default IPN;
